import axios from "axios";
export const state = {
    retail_outlets: [],
    save_status: false,

};
export const getters = {
    RetailOutlets: state => state.retail_outlets.data,
    SaveStatus: state => state.save_status,
};

export const mutations = {
    SET_RetailOutlets(state, newValue) {
        state.retail_outlets = newValue
    },

    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    }

};

export const actions = {

    fetchRetailOutlets({ commit }) {
        commit('SET_SAVE_STATUS', true)
        axios.get('retail_outlets').then(ec_res => {
            commit('SET_RetailOutlets', ec_res.data)
            commit('SET_SAVE_STATUS', false)
        })
    },

    addRetailOutlet({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('retail_outlets', payload).then(() => {
            dispatch('fetchRetailOutlets');
            let message = { 'msg': `Retail Outlet ${payload.name} added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Retail Outlet " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    editRetailOutlet({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`retail_outlets/${payload.id}`, payload).then(() => {
            dispatch('fetchRetailOutlets');
            let message = { 'msg': `Retail Outlet ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Updating Retail Outlet" }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteRetailOutlet({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`retail_outlets/${payload.id}`).then(() => {
            dispatch('fetchRetailOutlets');
            let message = { 'msg': `Retail Outlet ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Deleing Retail Outlet" + error }
            dispatch('notification/error', message, { root: true })
        })
    },

};